import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'dkPhoneNumber',
})
export class dkPhoneNumberPipe implements PipeTransform {
  transform(rawNum: any) {
    return rawNum.toString().replace(/\d{2}(?=.)/g, '$& ');
  }
}
